'use client';

import type { RefObject } from 'react';
import { useEffect } from 'react';

interface UseScrollableContentResetInput {
  containerRef: RefObject<HTMLElement | null>;
  ready: boolean;
}

export function useScrollableContentReset({
  containerRef,
  ready,
}: UseScrollableContentResetInput): void {
  useEffect(() => {
    if (!ready) {
      return;
    }

    const main = containerRef.current;

    if (!main) {
      return;
    }

    const tryReset = (): boolean => {
      if (main.scrollHeight <= main.clientHeight) {
        return false;
      }

      main.scrollTop = 0;
      return true;
    };

    if (tryReset()) {
      return;
    }

    const observer = new ResizeObserver(() => {
      if (tryReset()) {
        observer.disconnect();
      }
    });

    observer.observe(main);

    return () => {
      observer.disconnect();
    };
  }, [containerRef, ready]);
}
